document.addEventListener('turbolinks:load', function () {
    // if ($('#bank-payment').length === 0) {
    if ($('.payments.show, .fee_payments.show').length === 0) {
        return false
    }

    var token = $("meta[name='csrf-token']").attr('content');
    var form = document.getElementById('payment-form');
    var paymentId = form.className
    var initiateBankTransactionBtn = document.querySelector('.initiate-bank-btn');

    $(document).on('change', ".bank-transfers .new-method input[type='radio']", function () {
        let value = $(this).val()
        if ($(this).prop('checked') && value === "new_payment_method") {
            initialize()
        }
    })

    if (initiateBankTransactionBtn) {
        initiateBankTransactionBtn.addEventListener('click', function(e) {
            e.preventDefault()
            var newMethodRadio = $('#new_bank_method')
            if (newMethodRadio.length) {
                newMethodRadio.prop('checked', true).trigger('change')
            }
        })
    }

    function initialize() {
        $.ajax({
            url: "/payments/stripe_publishable_key",
            data: {
                authenticity_token: token
            },
            method: 'get'
        }).done(function (res) {
            if (res['error']) {
                alert(res['error'])
            } else {
                var key = res['key']
                createSetupIntent(key)
            }
        }).fail(function (res) {
            alert('Something went wrong')
        });
    }

    function createSetupIntent(publishable_key) {
        try {
            // Attempt Financial Connections first
            $.ajax({
                method: 'GET',
                url: '/bank_accounts/create_setup_intent',
                data: {
                    payment_id: paymentId
                }
            }).done(function (res) {
                if (res) {
                    var clientSecret = res.client_secret
                    var userIp = res.user_ip
                    var connectAccountId = res['connect_account_id']
                    var stripe = createStripeClient(publishable_key, connectAccountId)
                    var customerName = res.customer_name
                    var customerEmail = res.customer_email
                    collectBankAccountForSetup(stripe, clientSecret, userIp, customerName, customerEmail)
                } else {
                    alert('Something went wrong')
                }
            }).fail(function (res) {
                alert(res)
            })
        } catch (err) {
            // Financial Connections failed
            console.log("Financial Connections failed:", err.message);
        }
    }

    function createStripeClient(key, connectAccountId) {
        // Create a Stripe client.
        return Stripe(key, {stripeAccount: connectAccountId});
    }

    function collectBankAccountForSetup(stripe, clientSecret, userIp, customerName, customerEmail) {
        // Calling this method will open the instant verification dialog.
        stripe.collectBankAccountForSetup({
            clientSecret: clientSecret,
            params: {
                payment_method_type: 'us_bank_account',
                payment_method_data: {
                    billing_details: {
                        name: customerName,
                        email: customerEmail
                    },
                },
            },
            expand: ['payment_method'],
        }).then(({setupIntent, error}) => {
            console.log(setupIntent);
            if (error) {
                console.error(error.message);
                // PaymentMethod collection failed for some reason.
            } else if (setupIntent.status === 'requires_payment_method') {
                // Customer canceled the hosted verification modal. Present them with other
                // payment method type options.
            } else if (setupIntent.status === 'requires_confirmation') {
                // We collected an account - possibly instantly verified, but possibly
                // manually-entered. Display payment method details and mandate text
                // to the customer and confirm the intent once they accept
                // the mandate.

                showConfirmationForm(stripe, clientSecret, userIp)
            }
        });
    }

    function showConfirmationForm(stripe, clientSecret, userIp) {
        const modalElement = document.getElementById('confirmAccountModal');
        const modal = new bootstrap.Modal(modalElement);
        modal.show();

        const submitButton = document.getElementById('confirm-account-btn');
        submitButton.addEventListener('click', async (e) => {
            e.preventDefault();

            const accepted = document.getElementById('mandate-accept').checked;
            if (!accepted) return alert('You must accept the mandate to continue.');

            modal.hide();
            confirmBankAccount(stripe, clientSecret, userIp)
        });
    }

    function confirmBankAccount(stripe, clientSecret, userIp) {
        stripe.confirmUsBankAccountSetup(clientSecret, {
            mandate_data: {
                customer_acceptance: {
                    type: 'online',
                    online: {
                        ip_address: userIp,
                        user_agent: navigator.userAgent
                    }
                }
            }
        }).then((result) => {
            console.log(result);
            const { setupIntent, error } = result;
            if (error) {
                console.error(error.message);
                // The payment failed for some reason.
            } else if (setupIntent.status === "requires_payment_method") {
                // Confirmation failed. Attempt again with a different payment method.
            } else if (setupIntent.status === "succeeded") {
                show_ajax_notice('Bank account saved successfully.');

                // Reload the page to show the saved account
                setTimeout(function() {
                    window.location.reload();
                }, 1000);
            } else if (setupIntent.next_action?.type === "verify_with_microdeposits") {
                show_ajax_notice('Please verify your Bank account.');

                // Reload the page to show the saved account
                setTimeout(function() {
                    window.location.reload();
                }, 1500);
                // The account needs to be verified through microdeposits.
                // Display a message to consumer with next steps (consumer waits for
                // microdeposits, then enters a statement descriptor code on a page sent to them through email).
                // next_action: {
                //     type: "verify_with_microdeposits",
                //         verify_with_microdeposits: {
                //         arrival_date: 1647586800,
                //             hosted_verification_url: "https://payments.stripe.com/…",
                //             microdeposit_type: "descriptor_code"
                //     }
                // }
                // show these details to the user so that they can come here click on the link to verify their account
                // also need to save this information somewhere so that they can see this information whenever they want unless they verify their account
            }
        });
    }
});
